import React from "react";
import BOMPage from "../components/Bom/bomPage";

function BOM() {
  return (
    <div className="mt-5 space-y-5">
      <div className="w-full text-center border-b-2 pb-2">
        <div className="font-semibold" style={{ color: "#808080" }}>
          BOM
        </div>
      </div>
      <BOMPage />
    </div>
  );
}

export default BOM;
